var _style, _path, _path2, _path3, _path4, _path5, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarePlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "care-plan_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".care-plan_svg__st0{stroke-linejoin:round}.care-plan_svg__st0,.care-plan_svg__st1{fill:none;stroke:#344154;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st0",
    d: "M33.7 53.9l.1.1c3 1.8 4.6 5.2 4.1 8.7l-.2 1.8 2.9 10.3c1.1 3.8 3.7 6.9 7.3 8.6l6 2.8c7.3 3.4 12.8 9.8 15 17.6 1.4 4.8-1.2 9.9-6 11.6l-15.4 5.5c-3 1.1-4.5 4.4-3.3 7.4l3.4 8.5 20-7.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M41.8 95.2c-.4.1-.9.1-1.3.1-7 .6-13.7-2.6-18-8.1C13.6 75.9 6.9 83 6.9 83s7.3 8.8 12.3 17.4c3.5 6.2 9.3 10.8 16.2 12.6.4.1.9.2 1.3.3 4.5.9 8.3 3.9 10.4 7.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M13.5 80.9l-3-13.8L19.3 40s5.1 1.3 3.8 9l-4 17.7 2.7 11.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M22.5 42.8l2.4-7.3s6.6 2.4 4.4 11.2l-3.7 19.2 2.9 10.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M29.7 42.8l.3.2c3.1 2.3 4.6 6.1 3.9 9.9l-2.1 11.4 3 10.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st0",
    d: "M114.3 53.9l-.1.1c-3 1.8-4.6 5.2-4.1 8.7l.2 1.8-2.9 10.3c-1.1 3.8-3.7 6.9-7.3 8.6l-6 2.8c-7.3 3.4-12.8 9.8-15 17.6-1.4 4.8 1.2 9.9 6 11.6l15.4 5.5c3 1.1 4.5 4.4 3.3 7.4l-3.4 8.5-20-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M106.2 95.2c.4.1.9.1 1.3.1 7 .6 13.7-2.6 18-8.1 8.8-11.3 15.6-4.3 15.6-4.3s-7.3 8.8-12.3 17.4c-3.5 6.2-9.3 10.8-16.2 12.6-.4.1-.9.2-1.3.3-4.5.9-8.3 3.9-10.4 7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M134.5 80.9l3-13.8-8.8-27.1s-5.1 1.3-3.8 9l4 17.7-2.7 11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M125.5 42.8l-2.4-7.3s-6.6 2.4-4.4 11.2l3.7 19.2-2.9 10.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "care-plan_svg__st1",
    d: "M118.3 42.8l-.3.2c-3.1 2.3-4.6 6.1-3.9 9.9l2.1 11.4-3 10.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "care-plan_svg__XMLID_180_",
    className: "care-plan_svg__st1",
    d: "M74 22.5s4.7-10.9 15.5-10.2c5.7.4 10.9 3.7 13.5 8.8 1.7 3.3 2.7 7.8.9 13.4-.7 2-1.6 3.9-2.8 5.7-.5.7-1 1.3-1.5 2-2.4 2.8-6.9 7.2-11.4 11 0 0-11.4 9.2-14.1 15.2C71.4 62.3 60 53.2 60 53.2c-4.5-3.8-9-8.2-11.4-11-.5-.6-1-1.3-1.5-2-1.2-1.7-2.2-3.7-2.8-5.7-1.8-5.6-.8-10.1.9-13.4 2.6-5.1 7.8-8.5 13.5-8.8C69.3 11.6 74 22.5 74 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 20.4c-1.4-1.1-3.1-1.9-5.2-1.9H59c-3.6.2-6.8 2.3-8.4 5.5-1.4 2.6-1.5 5.4-.5 8.6.5 1.4 1.1 2.8 2 4.1.4.5.7 1 1.1 1.4 1.2 1.4 3.3 3.5 5.7 5.9-1-2.4-1.5-5-1.5-7.7 0-6.4 2.9-12.1 7.4-15.9z",
    fill: "#17c2c9"
  }))));
}
export default SvgCarePlan;